export default "__VITE_ASSET__DtCaVMc___"